import React, { useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import i18n from 'src/i18n.js';

const t = (key) => i18n.t(key);

import OrderHeader from './components/ordersHeader/OrdersHeader';
import {
    addScrollTopHandler,
    checkImpersonationActive,
    checkProxyActive,
    convertDateToISOString,
    displayDeniedOverride,
    fromOrderTypeToModuleName,
    procedureFilterData,
    removeScrollTopHandler,
    logErrorToConsole,
} from 'src/utils/util';
import OrdersListTableView from 'src/pages/orders/components/ordersListTableView/OrdersListTableView';
import ActionPanel from 'src/pages/home/component/actionsPanel/index';
/*Category */
import Category from './components/category/Category';

/* QuickFilter */
import QuickFiltersContainer from './components/quickFilters/QuickFilters';

import {
    QuickFilterLabels,
    CategoryLists,
    CategoryListsWithDeniedOverride,
    CategoryListsWithDeniedOverrideAndMast,
    CategoryListsWithMast,
} from 'src/constants/orderListConstants.js';

/* OrderDetails for orderList */
import OrderDetails from './components/orderDetails/OrderDetails';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
// SearchOrderResults table import
import SearchOrderResults from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult';
// Action import
import {
    getOrderListData,
    getAllOrderListData,
    setOrderSummaryModalState,
    closeOrderSummaryModalState,
    getDistrict,
    setOrdersListFilter,
    getRefinedOrderListData,
    setOrderStatus,
    getOrderSummaryData,
    setQuickFilter,
    setCategoryFilter,
    actionApplyFilterType,
    actionCategoryFilters,
    actionResetOrderList,
    setSearchParams,
    //resetAppliedFilter,
    setAppliedFilter,
    showHideSummaryModal,
    refineFilterAndOrderList, //Two Calls Actions
    showDeleteOrderAction,
    deleteOrder,
    setOrderDateAction,
    setDynamicZIndex,
    showHideSearchModalAction,
    toggleSearchResult,
    setLegacyMobileFilterDropdownAction,
    awaitingToggle,
    awaitingToggleMobile,
    resetOrderListFilter,
    setDeniedOverrideClicked,
    deniedToggle,
    deniedToggleFilter,
    deniedToggleTemp,
    getDeniedOrderFilter,
    deniedOverrideToggleClickChange,
    setItemListView,
} from 'src/pages/orders/redux/actions';
import OrdersListCardView from './components/ordersListCardView/OrdersListCardView';
import FilterResultsPanel from 'src/common/organisms/filterResultsPanel/FilterResultsPanel.jsx';
import { setActiveNavLink } from 'src/pages/home/redux/actions/index';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import DeleteOrderPopup from 'src/common/components/deleteOrderPopup/DeleteOrderPopup';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import {
    isMobileView,
    hideScrolling,
    resumeScrolling,
    setDynatracePageName,
    setCurrencyFormat,
} from 'src/utils/util';
import NoUsageToReportContainer from 'src/pages/reportUsage/noUsageToReport';
import {
    RESET_CANCEL_USAGE_STATES,
    SET_SHOW_CONTACT_LOGISTICS_POPUP,
} from 'src/pages/reportUsage/redux/action/types';
import { addDaysToDate } from 'src/utils/dateUtils';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import {
    ORDER_HISTORY_START_DATE,
    ORDER_HISTORY_END_DATE,
} from 'src/pages/more/pages/orderHistory';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { ORDERS, pageNames } from 'src/constants/appConstants';
import ReportProcedureData from 'src/pages/orders/components/orderDetails/ReportProcedureData/ReportProcedureData';
import ToggleButton from 'src/common/components/toggleButton/ToggleButton';
import Select from 'src/common/refactoredComponents/select/Select';
import SortGeneral from 'src/assets/images/SortGeneral.svg';
import TissueIcon from 'src/assets/images/TissueIcon.svg';
import NonTissueIcon from 'src/assets/images/NonTissueItemIcon.svg';
import PaymentInformationNeeded from 'src/assets/images/PaymentInformationNeeded.svg';
import BriefcaseIcon from 'src/assets/images/briefcase-check-outline.svg';
import {
    resetReportUsageStates,
    // setProcedureData,
    // setProcedureData_JP,
    // setProcedureInfo,
    resetLevelData,
} from '../reportUsage/redux/action/actionCreators';
import { getConfigurations } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Orders = (props) => {
    const isOrderHistory = props?.isOrderHistory || false;
    // Order History should not offer the "Denied Usage Overrides" category option. As it does not have price Override functionality.
    const excludeDeniedOverrideForHistory = (list) =>
        isOrderHistory
            ? list.filter(
                  (item) =>
                      item.categoryName !==
                      i18n.t('navLink.deniedUsageOverridesLabel')
              )
            : list;
    const dispatch = useDispatch();
    const { linkMyCaseRef } = useParams();
    const { pageLimit, filter } = useSelector(
        (state) => state.appliedOrdersFilterReducer
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const employeeRole = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.employeeRole
    );
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const history = useHistory();
    const location = useLocation();
    const appliedUserFilters = useSelector(
        (state) => state.appliedOrdersFilterReducer
    );
    const {
        orderSummaryModal,
        showReportProcedureModal,
        statusMessage: orderSummaryFailureStatusMessage,
        statusCode: orderSummaryFailureStatusCode,
    } = useSelector((state) => state.orderSummaryReducer);
   
    const {orderTypeVisibilityConfig} = useSelector((state) => state.loginReducer);
    const { searchParams, showSearchModal, showOrdersResult } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );

    const { isDeletePopup, deleteMyCaseRef, isOrderDetailsModal, isOtherUser } =
        useSelector((state) => state.deleteOrderReducer);
    const deleteLoading = useSelector(
        (state) => state.deleteOrderReducer.loading
    );
    const deleteStatusCode = useSelector(
        (state) => state.deleteOrderReducer.statusCode
    );

    const mastSurgery = useSelector(
        (state) => state.loginReducer.createOrderDetails.mastSurgery
    );

    const { orderListEndDate } = useSelector(
        (state) => state.ordersListReducer.ordersFilterDates
    );
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const isDeniedOverrideClicked = useSelector(
        (state) => state.ordersListReducer.isDeniedOverrideClicked
    );
    const procedureInfoDetails = useSelector(
        (state) => state.reportUsageRootReducer.procedureInfoDetails
    );
    const mobileFilterDropdownValue = useSelector(
        (state) =>
            state.legacyMobileFilterReducer?.legacyMobileFilterDropdownValue
    );
    const [retriggerEventNotification,setRetriggerEventNotification]=useState(false);
     const [notificationDetails,setNotificationDetails]=useState({});
    const PAGE_LIMIT = 50;
    const [categoryAnchorEl, setCategoryAnchorEl] = useState(null);
    const [categoryList, setCategoryList] = useState(
        excludeDeniedOverrideForHistory(
            displayDeniedOverride(
                checkImpersonationActive() || checkProxyActive()
                    ? sessionStorage.getItem('ProxyUserRole')
                    : employeeRole,
                countryISOCode
            ) && mastSurgery
                ? CategoryListsWithDeniedOverrideAndMast(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
                : displayDeniedOverride(
                      checkImpersonationActive() || checkProxyActive()
                          ? sessionStorage.getItem('ProxyUserRole')
                          : employeeRole,
                      countryISOCode
                  )
                ? CategoryListsWithDeniedOverride(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
                : mastSurgery
                ? CategoryListsWithMast(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
                : CategoryLists(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
        )
    );
    const [categoryName, setCategoryName] = useState(
        displayDeniedOverride(
            checkImpersonationActive() || checkProxyActive()
                ? sessionStorage.getItem('ProxyUserRole')
                : employeeRole,
            countryISOCode
        )
            ? CategoryListsWithDeniedOverride(orderTypeVisibilityConfig)[0].categoryName
            : CategoryLists(orderTypeVisibilityConfig)[0].categoryName
    );
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [quickFilterList, setQuickFilterList] = useState([]);
    const [showFullFilter, setShowFullFilter] = useState(false);
    const [showFilterIcon, setShowFilterIcon] = useState(false);
    const [filterActiveId, setFilterActiveId] = useState('');
    const [isShowNoOrders, setIsShowNoOrders] = useState(false);
    const [procedureInfoData, setProcedureInfoData] = useState({});
    const [toggleChecked, setToggleChecked] = useState(false);
    const [sortParam, setSortParam] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [isMobileSortFilter, setIsMobileSortFilter] = useState(false);
    const [isToggleHandlerChanged, setIsToggleHandlerChanged] = useState(false);
    const [showOrderSummaryFailurePopUp, setShowOrderSummaryFailurePopUp] =
        useState(false);

    const orderTableRef = useRef(null);
    const {
        appliedCategory,
        appliedQuickFilter,
        appliedFilter,
        appliedView,
        isFilterType,
        categoryFilters,
        notificationFailureList
    } = useSelector((state) => state.orderFilterReducer);

    const summaryLoading = useSelector(
        (state) => state.orderSummaryReducer.loading
    );
    const ordersLoading = useSelector(
        (state) => state.ordersListReducer.loading
    );
    const toggleCheckedDsktop = useSelector(
        (state) => state.ordersListReducer.toggleCheckedDsktop
    );
    const deniedOverrideToggle = useSelector(
        (state) => state.ordersListReducer.deniedOverrideToggle
    );
    const deniedOverrideToggleTemp = useSelector(
        (state) => state.ordersListReducer.deniedOverrideToggleTemp
    );
    const ToggleChecked = useSelector(
        (state) => state.ordersListReducer.ToggleChecked
    );
    const deniedOrderFilters = useSelector(
        (state) => state.ordersListReducer.deniedOrderFilters
    );
    const deniedOverrideToggleClick = useSelector(
        (state) => state.ordersListReducer.deniedOverrideToggleClick
    );
    const isErrorFoundInFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInFirstLevel
    );
    const isErrorFoundInProcedure = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInProcedure
    );
    useEffectWithErrorLogging(() => {
        sessionStorage.removeItem(`myCaseRefID`);
        dispatch(resetReportUsageStates());
        if (
            !(isOrderHistory && orderHistoryRestoredDataRef.current) &&
            !appliedView?.appliedOrderCondition
        ) {
            dispatch(resetOrderListFilter());
        }
    }, []);

    const { appliedOrderType, appliedOrderStatus,appliedNotificationFailure } = appliedFilter;
    const {
        appliedAccount,
        appliedDistrict,
        appliedTerritory,
        appliedOrderCondition,
    } = appliedView?.appliedOrderCondition
        ? appliedView
        : {
              appliedDistrict: {},
              appliedTerritory: {},
              appliedAccount: {},
              appliedOrderCondition: {},
          };

    const {
        orderList,
        totalSearcResults,
        filters,
        tissuePoSum,
        nonTissuePoSum,
        totalPoSum,
        
    } = useSelector((state) => state.ordersListReducer);

    // On an Order History browser refresh, redux-persist restores the order list
    // together with the applied filters/view. Capture (once, on first render) whether
    // we started with restored data so the automatic mount refetch below does not blank
    // the restored list. Scoped to Order History only so regular Orders is unaffected.
    const orderHistoryRestoredDataRef = useRef(
        isOrderHistory && Array.isArray(orderList) && orderList.length > 0
    );

    const orderHistoryLocationKeyRef = useRef(location?.key);
    const ordersReselectKeyRef = useRef(location?.key);
    const [ordersReselectTick, setOrdersReselectTick] = useState(0);

    const { startDate, endDate } = filter;

    // No Usage To Report
    const showCancelSurgeryPopup = useSelector(
        (state) => state.noUsageToReportReducer.showCancelSurgeryPopup
    );
    const showCaseCancelOrPostpone = useSelector(
        (state) => state.noUsageToReportReducer.showCaseCancelOrPostpone
    );
    const showNoUsageToReportPopup = useSelector(
        (state) => state.noUsageToReportReducer.showNoUsageToReportPopup
    );
    const viewProcedureScreen = useSelector(
        (state) => state.noUsageToReportReducer.viewProcedureScreen
    );
    const showUnidPostponePopup = useSelector(
        (state) => state.noUsageToReportReducer.showUnidPostponePopup
    );
    const callOrderOrCalendar = useSelector(
        (state) => state.updateSurgeryReducer.callOrderOrCalendar
    );
    const cancelSurgeryData = useSelector(
        (state) => state.noUsageToReportReducer.cancelSurgeryData
    );
    const isCancelWithoutReason = useSelector(
        (state) => state.noUsageToReportReducer.isCancelWithoutReason
    );
    const cancelUsageInProgress = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageInProgress
    );
    const cancelUsageResponse = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageResponse
    );
    const isFromOrderDetailsModal = useSelector(
        (state) => state.noUsageToReportReducer.isFromOrderDetailsModal
    );
    const showContactLogisticsPopup = useSelector(
        (state) => state.noUsageToReportReducer.showContactLogisticsPopup
    );
    const { updateSurgeryLoading } = useSelector((state) => ({
        updateSurgeryLoading: state.updateSurgeryReducer.updateSurgeryLoading,
    }));

    const allOrderListData = useSelector(
        (state) => state.ordersListReducer.allOrderList
    );
    // const filterList = useSelector(
    //     (state) => state.ordersListReducer.filterData
    // );
    // const isDeniedOverrideToggle = useSelector(
    //     (state) => state.ordersListReducer.isDeniedOverrideToggle
    // );
    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails,
        shallowEqual
    );

    const allOrderListStartDate =
        allOrderListData != null ? allOrderListData[0]?.submitDate : '';

    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );

    const minCreationImpersonatedDate = useSelector(
        (state) =>
            state.impersonatedUserDataReducer.hybrisUserDetails.minCreationDate
    );
    const minCreationUserDate = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.minCreationDate
    );
    const procedurePageVisibility = useSelector(
        (state) => state.loginReducer.procedurePageVisibility
    );

    const minCreationDate = isImpersonationActive
        ? minCreationImpersonatedDate
        : minCreationUserDate;

    const orderHistoryMinDate = useMemo(
        () => new Date(ORDER_HISTORY_START_DATE),
        []
    );


    const [firstOrderStartDate, setFirstOrderStartDate] = useState(
        isOrderHistory
            ? ORDER_HISTORY_START_DATE
            : addDaysToDate(minCreationDate, 0)
    );

    useEffectWithErrorLogging(() => {
        addScrollTopHandler();
        return () => removeScrollTopHandler();
    }, [isDeniedOverrideClicked]);

    useDynatracePageName(pageNames.orders);

    useEffectWithErrorLogging(() => {
        setFirstOrderStartDate(
            isOrderHistory
                ? ORDER_HISTORY_START_DATE
                : addDaysToDate(minCreationDate, 0)
        );
    }, [minCreationDate, isOrderHistory]);

    useEffectWithErrorLogging(() => {
        setCategoryList(
            excludeDeniedOverrideForHistory(
                displayDeniedOverride(
                    checkImpersonationActive() || checkProxyActive()
                        ? sessionStorage.getItem('ProxyUserRole')
                        : employeeRole,
                    countryISOCode
                ) && mastSurgery
                    ? CategoryListsWithDeniedOverrideAndMast(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
                    : displayDeniedOverride(
                          checkImpersonationActive() || checkProxyActive()
                              ? sessionStorage.getItem('ProxyUserRole')
                              : employeeRole,
                          countryISOCode
                      )
                    ? CategoryListsWithDeniedOverride(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
                    : mastSurgery
                    ? CategoryListsWithMast(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
                    : CategoryLists(orderTypeVisibilityConfig).filter((item)=>item.isVisible)
            )
        );
    }, [userDetails]);
    useEffectWithErrorLogging(() => {
        dispatch(resetLevelData());
    }, [showReportProcedureModal]);

    useEffectWithErrorLogging(() => {
        if (
            isCancelWithoutReason &&
            cancelUsageResponse &&
            cancelUsageResponse.statusCode === '200'
        ) {
            if (isFromOrderDetailsModal && cancelUsageResponse.myCaseRef) {
                dispatch(setOrderStatus({ orderStatus: '' }));
                dispatch(getOrderSummaryData());
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: cancelUsageResponse.myCaseRef,
                        orderSummaryModal: true,
                        isFromOrderHistory: isOrderHistory,
                    })
                );
            }
            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        startDate: convertDateToISOString(
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    },
                    startDate: convertDateToISOString(
                        // minCreationDate,
                        new Date(firstOrderStartDate),
                        'start'
                    ),
                      isFromOrderHistory:isOrderHistory,
                })
            );
            dispatch({ type: RESET_CANCEL_USAGE_STATES });
        }
    }, [isCancelWithoutReason, cancelUsageResponse]);
    useEffectWithErrorLogging(() => {
        if (orderSummaryFailureStatusCode === '10811') {
            setShowOrderSummaryFailurePopUp(true);
        }
    }, [orderSummaryFailureStatusMessage, orderSummaryFailureStatusCode]);

    useEffectWithErrorLogging(() => {
        if (isMobileSortFilter) {
            dispatch(
                setOrdersListFilter({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        deniedOverrides:
                            deniedOverrideToggle || isDeniedOverrideClicked
                                ? true
                                : false,
                        orderStatusCode:
                            deniedOverrideToggle || isDeniedOverrideClicked
                                ? '12347,12348'
                                : filter.orderStatusCode,
                        orderType:
                            deniedOverrideToggle || isDeniedOverrideClicked
                                ? 'ZLB'
                                : filter.orderType === 'ALL_ORDERS'
                                ? ''
                                : filter.orderType,
                    },
                    startDate:
                        // firstOrderStartDate,
                        convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    sortParam: sortParam,
                    // sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                    sortOrder: sortOrder,
                })
            );
            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        deniedOverrides:
                            deniedOverrideToggle || isDeniedOverrideClicked
                                ? true
                                : false,
                        orderStatusCode:
                            deniedOverrideToggle || isDeniedOverrideClicked
                                ? '12347,12348'
                                : filter.orderStatusCode,
                        orderType:
                            deniedOverrideToggle || isDeniedOverrideClicked
                                ? 'ZLB'
                                : filter.orderType === 'ALL_ORDERS'
                                ? ''
                                : filter.orderType,
                        startDate: convertDateToISOString(
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    },
                    startDate: convertDateToISOString(
                        new Date(firstOrderStartDate),
                        'start'
                    ),
                    sortParam: sortParam,
                    sortOrder: sortOrder,
                      isFromOrderHistory:isOrderHistory,
                })
            );
            setIsMobileSortFilter(false);
        }
    }, [sortOrder, sortParam, isMobileSortFilter]);
    const onhandleFilterChange = (value) => {
        dispatch(setLegacyMobileFilterDropdownAction(value));

        if (value === 'order_date_newest' || value === 'order_date_oldest') {
            setSortParam('submitDate');
            if (value === 'order_date_newest') {
                setSortOrder('DESC');
            } else {
                setSortOrder('ASC');
            }
        } else {
            setSortParam('accountName');
            if (value === 'account_az') {
                setSortOrder('ASC');
            } else {
                setSortOrder('DESC');
            }
        }
        setIsMobileSortFilter(true);
    };

    
    //     let data = '';
    //     if (
    //         additionalProcedure &&
    //         countryISOCode === 'JP' &&
    //         procedurePageVisibility
    //     ) {
    //         data = procedureFilterData(
    //             [
    //                 { name: 'Powerease', code: '01' },
    //                 { name: 'Stealth S7/S8 Navigation', code: '02' },

    //                 { name: 'Advanced Energy', code: '03' },
    //                 { name: 'MazorX Robot Used', code: '04' },
    //             ],
    //             additionalProcedure ? additionalProcedure : '',
    //             additionalProcedure[0] === 'Additional_Procedure_Data'
    //                 ? 'Additional_Procedure_Data'
    //                 : false,
    //             advancedEnergy[0] === 'Advanced Energy' ||
    //                 advancedEnergy.length === 0
    //                 ? false
    //                 : advancedEnergy
    //         );
    //         dispatch(setProcedureData('additionalProcedure', data));

    //         dispatch(setProcedureInfo('additionalProcedure', data));
    //     }

    //     if (
    //         deformityCorrection &&
    //         countryISOCode === 'JP' &&
    //         procedurePageVisibility
    //     ) {
    //         data = procedureFilterData(
    //             [
    //                 { code: '87', name: 'None' },
    //                 { code: '86', name: 'Smartlink' },
    //             ],
    //             deformityCorrection ? deformityCorrection : '',
    //             deformityCorrection[0] === 'DEFORMITY_CORRECTION' ||
    //                 deformityCorrection[0] === 'deformity_correction'
    //                 ? 'DEFORMITY_CORRECTION'
    //                 : false
    //         );
    //         dispatch(setProcedureData('technologies', data));
    //         dispatch(setProcedureInfo('technologies', data));
    //     }

    //     if (
    //         biologicsUsed &&
    //         countryISOCode === 'JP' &&
    //         procedurePageVisibility
    //     ) {
    //         data = procedureFilterData(
    //             [
    //                 { name: 'None', code: '01' },
    //                 { name: 'Yes (Medtronic/Competitive)', code: '02' },
    //                 { name: 'Autograft/Patient Derived', code: '03' },
    //             ],
    //             biologicsUsed ? biologicsUsed : '',
    //             biologicsUsed[0] === 'BIOLOGICS_USED' ||
    //                 biologicsUsed[0] === 'biologics_used'
    //                 ? 'BIOLOGICS_USED'
    //                 : false
    //         );
    //         dispatch(setProcedureData('biologicsUsed', data));
    //         dispatch(setProcedureInfo('biologicsUsed', data));
    //     }

    //     if (
    //         physicianFinderEligibility &&
    //         countryISOCode === 'JP' &&
    //         procedurePageVisibility
    //     ) {
    //         data = procedureFilterData(
    //             [
    //                 { name: 'None', code: 'n/a' },
    //                 { name: '3D Image Guided/Navigation', code: '22' },
    //                 { name: 'Back Surgery', code: '20' },
    //                 { name: 'Cervical Disc Arthroplasty', code: '19' },
    //                 { name: 'Sacroiliac Joint Fusion', code: '23' },
    //                 { name: 'Scoliosis', code: '24' },
    //                 { name: 'Spine Robotics', code: '32' },
    //             ],
    //             physicianFinderEligibility ? physicianFinderEligibility : '',
    //             physicianFinderEligibility[0] ===
    //                 'PHYSICIAN_FINDER_ELIGIBILITY' ||
    //                 physicianFinderEligibility[0] ===
    //                     'physician_finder_eligibility'
    //                 ? 'PHYSICIAN_FINDER_ELIGIBILITY'
    //                 : false,
    //             'physicianFinderEligibility'
    //         );
    //         dispatch(setProcedureData('therapies', data));
    //         dispatch(setProcedureInfo('therapies', data));
    //     }

    //     if (
    //         biologicsDetail &&
    //         countryISOCode === 'JP' &&
    //         procedurePageVisibility
    //     ) {
    //         data = procedureFilterData(
    //             [
    //                 {
    //                     name: 'Allograft@ex: Cornerstone, Chips and Cubes',
    //                     code: '01',
    //                 },
    //                 { name: 'Proteins/Peptides@ex: Infuse', code: '02' },
    //                 { name: 'Stem Cell Products@ex: CBMs, VBMs', code: '03' },
    //                 { name: 'DBM@ex: Grafton, Magnifuse', code: '04' },
    //                 { name: 'Synthetics@ex: Mastergraft', code: '05' },
    //             ],
    //             biologicsDetail ? biologicsDetail : '',
    //             biologicsDetail[0] === 'BIOLOGICS' ||
    //                 biologicsDetail[0] === 'biologics'
    //                 ? 'BIOLOGICS'
    //                 : false,
    //             !biologicsUsed?.includes('Yes (Medtronic/Competitive)')
    //                 ? 'biologicsUsed'
    //                 : ''
    //         );
    //         dispatch(setProcedureData('biologicsDetail', data));
    //         dispatch(setProcedureInfo('biologicsDetail', data));
    //     }

    //     if (
    //         retractorUsed &&
    //         countryISOCode === 'JP' &&
    //         procedurePageVisibility
    //     ) {
    //         data = procedureFilterData(
    //             [
    //                 { name: 'None', code: '01' },
    //                 { name: 'McCulloch Retractor', code: '02' },
    //                 { name: 'ALOP', code: '03' },
    //                 { name: 'Tedan Phantom', code: '04' },
    //                 { name: 'Precision', code: '05' },
    //                 { name: 'Thompson OLIF25', code: '06' },
    //                 { name: 'Thompson OLIF51', code: '07' },
    //                 { name: 'Thompson ALIF Ring Retractor', code: '08' },
    //                 { name: 'DLIF (Older Gen.)', code: '09' },
    //                 { name: 'Trimline', code: '10' },
    //                 {
    //                     name: 'Space D Distractor-Compressor System',
    //                     code: '11',
    //                 },
    //                 { name: 'Quadrant Retractor', code: '12' },
    //                 { name: 'METRx', code: '13' },
    //                 { name: 'ModuleX Midline Retractor', code: '14' },
    //                 { name: 'Other', code: '15' },
    //             ],
    //             retractorUsed ? retractorUsed : '',
    //             retractorUsed[0] === 'RETRACTOR_USED' ||
    //                 retractorUsed[0] === 'retractor_used'
    //                 ? 'RETRACTOR_USED'
    //                 : false,
    //             'retractorUsed'
    //         );

    //         dispatch(setProcedureData('retractors', data));
    //         dispatch(setProcedureInfo('retractors', data));
    //     }

    //     // advancedEnergy
    //     //     ? dispatch(
    //     //           setProcedureData_JP(
    //     //               'advancedEnergy',
    //     //               procedureFilterData(
    //     //                   ['Aquamantys', 'PlasmaBlade X'],
    //     //                   advancedEnergy ? advancedEnergy : ''
    //     //               )
    //     //           )
    //     //       )
    //     //     : '';
    // }, []);

    // useEffectWithErrorLogging(() => {
    //     let quickFilter = QuickFilterLabels(categoryName);

    //     // let orderTypeIndex = categoryList.findIndex(
    //     //     (x) => x.categoryName === appliedCategory.categoryName
    //     // );
    //     // const orderTypeId = categoryList[orderTypeIndex]?.orderType;

    //     // quickFilter = quickFilterApply(quickFilter, orderTypeId);

    //     setQuickFilterList(quickFilter);

    //     if (quickFilter?.length > 0) {
    //         setFilterActiveId(quickFilter[0].id);
    //         dispatch(setQuickFilter({ ...quickFilter[0] }));
    //     } else {
    //         setFilterActiveId('');
    //         dispatch(setQuickFilter({}));
    //     }
    // }, [categoryName]);
    useEffectWithErrorLogging(() => {
        if (procedureInfoDetails) {
            setProcedureInfoData({
                ...procedureInfoData,
                ...procedureInfoDetails,
            });
        }
    }, [procedureInfoDetails]);
    useEffectWithErrorLogging(() => {
        const isResetView =
            isFilterType === 'ResetFilter'
                ? isFilterType === 'ResetFilter' &&
                  filter.orderType === '' &&
                  appliedCategory.categoryName ===
                      t('orders.orderListFilterDropDown.all.categoryName')
                    ? true
                    : false
                : true;
        if (
            isFilterType !== 'AppliedFilter' &&
            (deniedOverrideToggleClick
                ? true
                : isFilterType !== 'quickFilter') &&
            isFilterType !== 'pagination' &&
            isFilterType !== 'pageSort' &&
            isResetView
        ) {
            dispatch(deniedOverrideToggleClickChange(false));
            if (appliedCategory?.isQuickFilter) {
                let quickFilter = QuickFilterLabels(categoryName);
                let orderTypeIndex = categoryList.findIndex(
                    (x) => x.categoryName === appliedCategory.categoryName
                );
                const orderTypeId = categoryList[orderTypeIndex]?.orderType;

                quickFilter =
                    appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.drafts')
                        ? orderStatusBasedQuickFilter(quickFilter)
                        : quickFilterApply(quickFilter, orderTypeId);
                // if (deniedOverrideToggle) {
                //     let filterIndex = quickFilter.findIndex(
                //         (filter) => filter.label === 'Pending Override'
                //     );
                //     let updatedPendingOverride = {
                //         ...quickFilter[filterIndex],
                //         count: deniedOrderFilters[0]?.orderStatusList[0]?.count ? deniedOrderFilters[0]?.orderStatusList[0]?.count : 0,
                //     };
                //     const newArray = [...quickFilter];
                //     newArray[filterIndex] = updatedPendingOverride;
                //     setQuickFilterList(newArray);
                // } else {
                setQuickFilterList(quickFilter);
                // }
            }
            dispatch(actionCategoryFilters({ categoryFilters: filters }));
        }
        // if (
        //     appliedQuickFilter.id === 4 &&
        //     appliedQuickFilter.label === 'Pending Override'
        // ) {
        //     let category = { ...categoryFilters };
        //     let filterData =
        //         // isDeniedOverrideToggle
        //         //     ? { ...filterList }
        //         //     :
        //         { ...filters };
        //     let updatedFilter =
        //         orderList.length > 0
        //             ? category[0]?.orderStatusList?.map((data) => {
        //                   if (
        //                       data?.code?.includes('12347') ||
        //                       data.code?.includes('12348')
        //                   ) {
        //                       return filterData[0]?.orderStatusList?.filter(
        //                           (d) =>
        //                               d?.code?.includes('12347') ||
        //                               d?.code?.includes('12348')
        //                       )[0];
        //                   } else {
        //                       return data;
        //                   }
        //               })
        //             : category[0]?.orderStatusList?.map((data) => {
        //                   if (
        //                       data?.code?.includes('12347') ||
        //                       data.code?.includes('12348')
        //                   ) {
        //                       return { ...data, count: 0 };
        //                   } else {
        //                       return data;
        //                   }
        //               });
        //     let quickFilterLabel = QuickFilterLabels('Usage');
        //     let orderTypeIndexValue = categoryList.findIndex(
        //         (x) => x.categoryName === appliedCategory.categoryName
        //     );
        //     const orderTypeIdValue =
        //         categoryList[orderTypeIndexValue]?.orderType;

        //     quickFilterLabel = filterApply(
        //         quickFilterLabel,
        //         orderTypeIdValue,
        //         updatedFilter
        //     );

        //     setQuickFilterList(quickFilterLabel);
        //     // setQuickFilterList(updatedFilter);
        //     // dispatch(actionCategoryFilters({ categoryFilters: updatedFilter }));
        // }
        onNoRecordsHandler();
    }, [orderList, deniedOrderFilters]);

    // useEffectWithErrorLogging(() => {
    //     preventBouncingEffect;
    //     return () => {
    //         revertBouncingEffect();
    //     };
    // }, []);

    const quickFilterApply = (quickFilter, orderTypeId) => {
        return quickFilter?.map((filter) => {
            if (isOrderHistory) {
                return {
                    ...filter,
                    count:
                        filter.id === 1
                            ? totalSearcResults || orderList?.length || 0
                            : 0,
                };
            }

            const orderDescription = [];

            const orderTypes = orderTypeId?.split(',');

            const filtersIndex = filters?.filter((x) =>
                orderTypes?.includes(x.orderType)
            );

            var filtersList = filtersIndex?.reduce(
                (accumulator, currentValue) => {
                    return [...accumulator, ...(currentValue?.orderStatusList || [])];
                },
                []
            );
            if (deniedOverrideToggle || deniedOverrideToggleTemp) {
                let filterIndex = filtersList.findIndex(
                    (filter) =>
                        filter.description ===
                        t('orders.orderStatuses.submittedPendingPriceOverride')
                );
                let updatedPendingOverride = {
                    ...filtersList[filterIndex],
                    count: deniedOrderFilters[0]?.orderStatusList[0]?.count
                        ? deniedOrderFilters[0]?.orderStatusList[0]?.count
                        : '0',
                };
                const newArray = [...filtersList];
                newArray[filterIndex] = updatedPendingOverride;
                filtersList = newArray;
            }

            if (filtersList?.length > 0) {
                filter?.statusNotes?.length > 0 &&
                    orderDescription.push(...filter.statusNotes);
                if (filter.id === 1) {
                    return {
                        ...filter,
                        count: filtersList
                            .map((x) => x.count)
                            .reduce((acc, curr) => acc + parseInt(curr), 0),
                    };
                }

                const selectedFilterIndex = filtersList
                    .filter((x) => orderDescription.includes(x.description))
                    .reduce((acc, curr) => acc + parseInt(curr.count || 0), 0); 
                    
                return {
                    ...filter,
                    count:
                        selectedFilterIndex >= 0
                            ? selectedFilterIndex
                            : 0,
                };
            }

            return {
                ...filter,
                count: 0,
            };
        });
    };
    const filterApply = (quickFilter, orderTypeId, filtersList) => {
        return quickFilter?.map((filter) => {
            const orderDescription = [];
            if (filtersList?.length > 0) {
                filter?.statusNotes?.length > 0 &&
                    orderDescription.push(...filter?.statusNotes);
                if (filter.id === 1) {
                    return {
                        ...filter,
                        count: filtersList
                            .map((x) => x?.count)
                            .reduce((acc, curr) => acc + parseInt(curr), 0),
                    };
                }
                const selectedFilterIndex = filtersList.findIndex((order) => {
                    return orderDescription.includes(order?.description);
                });
                return {
                    ...filter,
                    count:
                        selectedFilterIndex >= 0
                            ? filtersList[selectedFilterIndex]?.count
                            : 0,
                };
            }

            return {
                ...filter,
                count: 0,
            };
        });
    };

    const orderStatusBasedQuickFilter = (quickFilter) => {
        return quickFilter?.map((filter) => {
            const orderStatus = appliedCategory.orderType;
            const orderType = filter.statusNotes.join(',');
            if (filter.id === 1) {
                const draftsList = filters.map((x) => {
                    return x.orderStatusList.filter(
                        (statusList) => statusList.code === orderStatus
                    );
                });

                const codeCount =
                    draftsList.length > 0
                        ? draftsList
                              ?.reduce((accumulator, currentValue) => {
                                  return [...accumulator, ...(currentValue || [])];
                              }, [])
                              ?.reduce(
                                  (acc, curr) =>
                                      acc +
                                      (curr?.count ? parseInt(curr.count) : 0),
                                  0
                              )
                        : '';

                return {
                    ...filter,
                    count: codeCount,
                };
            } else {
                let orderTypeCount = 0;
                const orderTypeIndex = filters.findIndex((x) => {
                    return x.orderType === orderType;
                });

                if (orderTypeIndex >= 0) {
                    orderTypeCount = filters[orderTypeIndex]?.orderStatusList
                        ?.map((x) => {
                            if (x.code === orderStatus) {
                                return x.count;
                            } else {
                                return 0;
                            }
                        })
                        ?.reduce((acc, curr) => acc + parseInt(curr), 0);
                }

                return {
                    ...filter,
                    count: orderTypeCount,
                };
            }
        });
    };

    useEffectWithErrorLogging(() => {
        if (
            deleteStatusCode &&
            deleteStatusCode !== '' &&
            deleteStatusCode === '10707'
        ) {
            dispatch(actionApplyFilterType('delete'));
            if (!linkMyCaseRef) {
                closeOrderSummaryHandler();
            }
            const checkCategorySelectedEmpty =
                Object.keys(appliedCategory).length === 0 &&
                appliedCategory.constructor === Object;

            if (
                checkCategorySelectedEmpty ||
                appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.all.categoryName') ||
                appliedCategory.categoryName ===
                    t(
                        'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
                    )
            ) {
                //Normal Flow for Non-QuickFilters
                dispatch(
                    getRefinedOrderListData({
                        ...appliedUserFilters,
                        filter: {
                            ...filter,
                            startDate: convertDateToISOString(
                                new Date(firstOrderStartDate),
                                'start'
                            ),
                        },
                        startDate: convertDateToISOString(
                            firstOrderStartDate,
                            'start'
                        ),
                          isFromOrderHistory:isOrderHistory,
                    })
                );
            } else {
                //Two API Flow for QuickFilters
                twoCallAPIHandler(true, false);
            }
        }
    }, [deleteStatusCode]);

    const {
        account,
        hrefId,
        physician,
        surgeryDate,
        networkId,
        patientName,
        procedure,
        lotSerialNumber,
        myCaseRef,
        sapOrderId,
        purchaseOrderId,
        unidCaseId,
        trackingNumber,
        delivery,
        secondaryVendorCaseNo,
    } = searchParams;

    const skipOrderHistoryStaleSearchRef = useRef(isOrderHistory);

    useEffectWithErrorLogging(() => {
        const checkSearchParamsSet =
            account !== '' ||
            hrefId !== '' ||
            physician !== '' ||
            surgeryDate !== '' ||
            networkId !== '' ||
            patientName !== '' ||
            procedure !== '' ||
            lotSerialNumber !== '' ||
            myCaseRef !== '' ||
            sapOrderId !== '' ||
            purchaseOrderId !== '' ||
            unidCaseId !== '' ||
            trackingNumber !== '' ||
            delivery !== '' ||
            secondaryVendorCaseNo !== '';
        //setShowSearchOrderResultsTable(checkSearchParamsSet);
        if (skipOrderHistoryStaleSearchRef.current) {
            skipOrderHistoryStaleSearchRef.current = false;
            dispatch(showHideSearchModalAction({ showSearchModal: false }));
            return;
        }
        dispatch(
            showHideSearchModalAction({ showSearchModal: checkSearchParamsSet })
        );
    }, [searchParams]);

    const onCategoryOpenHandler = (e) => {
        setCategoryAnchorEl(e.currentTarget);
        setCategoryOpen((prevState) => !prevState);
    };

    useEffectWithErrorLogging(() => {
        dispatch(awaitingToggle(false));
    }, []);
    //On Category Change , Setting Category Name in local useState, dispatch action to Save Category in reducer,
    //Clear Applied filters and Call API.
    const onCategoryChangeHandler = (Id) => {
        dispatch(deniedToggle(false));
        dispatch(deniedToggleTemp(false));
        if (
            appliedCategory.categoryName ===
            t('orders.orderQuickFilters.deniedUsageOverrides.name')
        ) {
            dispatch(setLegacyMobileFilterDropdownAction());
        }

        const oldCatList = [...categoryList];
        const categoryIndex = oldCatList.findIndex((cat) => cat.id === +Id);
        const categoryName = categoryList[categoryIndex].categoryName;
        setCategoryName(categoryName);

        if (
            Id === 3 &&
            categoryName ===
                t('orders.orderQuickFilters.deniedUsageOverrides.name')
        ) {
            dispatch(setLegacyMobileFilterDropdownAction());
            dispatch(setDeniedOverrideClicked(true));
            document.getElementById('ordersContainer')?.scrollTo(0, 0);
        } else {
            dispatch(setDeniedOverrideClicked(false));
        }
        setCategoryOpen((prevState) => !prevState);
        dispatch(setCategoryFilter({ ...categoryList[categoryIndex] }));

        let quickFilter = QuickFilterLabels(categoryName);
        setQuickFilterList(quickFilter);

        if (quickFilter?.length > 0) {
            setFilterActiveId(quickFilter[0].id);
            dispatch(setQuickFilter({ ...quickFilter[0], statusCode: '' }));
        } else {
            setFilterActiveId('');
            dispatch(setQuickFilter({}));
        }

        resetAppliedFilter();
        dispatch(awaitingToggle(false));
        dispatch(awaitingToggleMobile(false));
        dispatch(actionApplyFilterType('category'));

        dispatch(
            setOrdersListFilter({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    deniedOverrides:
                        Id === 3 &&
                        displayDeniedOverride(
                            checkImpersonationActive() || checkProxyActive()
                                ? sessionStorage.getItem('ProxyUserRole')
                                : employeeRole,
                            countryISOCode
                        )
                            ? true
                            : false,
                    startDate:
                        // firstOrderStartDate,
                        convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    orderStatusCode:
                        Id === 3 &&
                        displayDeniedOverride(
                            checkImpersonationActive() || checkProxyActive()
                                ? sessionStorage.getItem('ProxyUserRole')
                                : employeeRole,
                            countryISOCode
                        )
                            ? '12347,12348'
                            : categoryList[categoryIndex].categoryName ===
                              t('orders.orderListFilterDropDown.drafts')
                            ? categoryList[categoryIndex].orderType
                            : '',
                    orderType:
                        categoryList[categoryIndex].categoryName ===
                            t(
                                'orders.orderListFilterDropDown.all.categoryName'
                            ) ||
                        categoryList[categoryIndex].categoryName ===
                            t('orders.orderListFilterDropDown.drafts')
                            ? ''
                            : categoryList[categoryIndex].orderType ===
                              'ALL_ORDERS'
                            ? ''
                            : categoryList[categoryIndex].orderType,
                    assignedFlag: filter.assignedFlag,
                },
                pageLimit: PAGE_LIMIT,
                pageNo: 0,
            })
        );

        dispatch(
            getRefinedOrderListData({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    deniedOverrides:
                        Id === 3 &&
                        displayDeniedOverride(
                            checkImpersonationActive() || checkProxyActive()
                                ? sessionStorage.getItem('ProxyUserRole')
                                : employeeRole,
                            countryISOCode
                        )
                            ? true
                            : false,
                    startDate: convertDateToISOString(
                        // minCreationDate,
                        new Date(firstOrderStartDate),
                        'start'
                    ),
                    // firstOrderStartDate,
                    //orderType: categoryList[categoryIndex].orderType,
                    orderStatusCode:
                        Id === 3 &&
                        displayDeniedOverride(
                            checkImpersonationActive() || checkProxyActive()
                                ? sessionStorage.getItem('ProxyUserRole')
                                : employeeRole,
                            countryISOCode
                        )
                            ? '12347,12348'
                            : categoryList[categoryIndex].categoryName ===
                              t('orders.orderListFilterDropDown.drafts')
                            ? categoryList[categoryIndex].orderType
                            : '',
                    orderType:
                        categoryList[categoryIndex].categoryName ===
                            t(
                                'orders.orderListFilterDropDown.all.categoryName'
                            ) ||
                        categoryList[categoryIndex].categoryName ===
                            t('orders.orderListFilterDropDown.drafts')
                            ? ''
                            : categoryList[categoryIndex].orderType ===
                              'ALL_ORDERS'
                            ? ''
                            : categoryList[categoryIndex].orderType,
                    assignedFlag: filter.assignedFlag,
                },
                pageLimit: PAGE_LIMIT,
                pageNo: 0,
                  isFromOrderHistory:isOrderHistory,
            })
        );
    };

    const resetAppliedFilter = () => {
        appliedFilter.appliedOrderType = [];
        appliedFilter.appliedOrderStatus = [];

        dispatch(
            setAppliedFilter({
                appliedView: appliedView,
                appliedFilter: appliedFilter,
            })
        );
    };

     const resetView = () => {
        appliedFilter.appliedOrderType = [];
        appliedFilter.appliedOrderStatus = [];

        // Clear applied views by resetting the appliedView object
        const clearedAppliedView = {
            appliedDistrict: {},
            appliedTerritory: {},
            appliedAccount: {},
            appliedOrderCondition: {},
        };

        dispatch(
            setAppliedFilter({
                appliedView: clearedAppliedView,
                appliedFilter: appliedFilter,
            })
        );
    };

    function handleClearClick() {
        // Reset both filters and views
        appliedFilter.appliedOrderType = [];
        appliedFilter.appliedOrderStatus = [];
        appliedFilter.appliedNotificationFailure = [];

        dispatch(
            setAppliedFilter({
                appliedView: {
                    appliedDistrict: {},
                    appliedTerritory: {},
                    appliedAccount: {},
                    appliedOrderCondition: {},
                },
                appliedFilter: appliedFilter,
            })
        );
        // resetView();
        
        dispatch(actionApplyFilterType('ResetFilter'));
        
        dispatch(
            setOrdersListFilter({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    startDate: convertDateToISOString(
                        new Date(firstOrderStartDate),
                        'start'
                    ),
                    endDate: endDate,
                    orderType: '',
                    orderStatusCode: '',
                    notificationFailure: false,
                    account: '',
                    district: '',
                    territory: '',
                    assignedFlag: true,
                },
            })
        );
        
        dispatch(
            getRefinedOrderListData({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    account:'',
                    district:'',
                    territory:'',
                    assignedFlag:true,
                    startDate: convertDateToISOString(
                        new Date(firstOrderStartDate),
                        'start'
                    ),
                    endDate: endDate,
                    orderType: '',
                    orderStatusCode: '',
                    notificationFailure: false,
                },
                  isFromOrderHistory:isOrderHistory,
            })
        );
    }

    useEffectWithErrorLogging(() => {
        if (quickFilterList?.length > 4) {
            setShowFilterIcon(true);
            setShowFullFilter(false);
        } else {
            setShowFilterIcon(false);
            setShowFullFilter(false);
        }
    }, [quickFilterList]);

    // useEffectWithErrorLogging(() => {
    //     if (
    //         showSearchModal ||
    //         orderSummaryModal ||
    //         showSaveAsTemplate ||
    //         sendReportModal ||
    //         requestInvoiceState
    //     ) {
    //         preventBouncingEffect();
    //         hideScrolling();
    //     } else {
    //         resumeScrolling();
    //         revertBouncingEffect();
    //     }
    // }, [
    //     showSearchModal,
    //     orderSummaryModal,
    //     showSaveAsTemplate,
    //     sendReportModal,
    //     requestInvoiceState,
    // ]);

    useEffectWithErrorLogging(() => {
        return () => {
            resumeScrolling();
        };
    }, []);
    const onFilterClick = () => {
        setShowFullFilter((prevState) => !prevState);
    };

    const onFilterActiveHandler = (Id) => {
        if (Id === 4 && deniedOverrideToggleTemp) {
            dispatch(deniedToggle(true));
        } else {
            dispatch(deniedToggle(false));
        }
        setFilterActiveId(+Id);
        const selectedQuickFilter = quickFilterList.find((x) => x.id === +Id);

        const filterNames = selectedQuickFilter?.statusNotes;

        const orderType =
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') ||
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.drafts')
                ? ''
                : appliedCategory.orderType;

        const orderTypes = orderType?.split(',');

        const filtersIndex = categoryFilters?.filter((x) =>
            orderTypes?.includes(x.orderType)
        );

        const filtersList = filtersIndex?.reduce(
            (accumulator, currentValue) => {
                return [...accumulator, ...(currentValue?.orderStatusList || [])];
            },
            []
        );

        const statusCodeList = Array.from(
            new Set(
                filtersList
                    ?.filter((x) => filterNames.includes(x?.description))
                    .map((x) => x.code)
            )
        );

        const statusCode =
            appliedCategory.categoryName ===
            t('orders.orderListFilterDropDown.drafts')
                ? selectedQuickFilter.statusNotes.join(',')
                : statusCodeList?.length > 0
                ? statusCodeList.join(',')
                : '';
        // dispatch(
        //     resetAppliedFilter({
        //         appliedFilter: {
        //             appliedOrderType: [],
        //             appliedOrderStatus: [],
        //         },
        //     })
        // );
        resetAppliedFilter();

        dispatch(
            setQuickFilter({ ...selectedQuickFilter, statusCode: statusCode })
        );

        if (!selectedQuickFilter.isDefault) {
            dispatch(actionApplyFilterType('quickFilter'));
        } else {
            dispatch(actionApplyFilterType('initial'));
        }
        //Will not call any api when quick filter count is Zero and reset orderList to empty
        if (selectedQuickFilter.count === 0) {
            dispatch(actionResetOrderList());
        } else {
            dispatch(
                setOrdersListFilter({
                    filter: {
                        ...filter,
                        startDate: convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                        // firstOrderStartDate,
                        orderStatusCode:
                            appliedCategory?.categoryName ===
                            t('orders.orderListFilterDropDown.drafts')
                                ? appliedCategory?.orderType
                                : statusCode,
                        orderType:
                            appliedCategory?.categoryName ===
                            t('orders.orderListFilterDropDown.drafts')
                                ? selectedQuickFilter?.statusNotes.join(',')
                                : filter.orderType === 'ALL_ORDERS'
                                ? ''
                                : filter.orderType,
                    },
                    pageLimit: PAGE_LIMIT,
                    pageNo: 0,
                })
            );

            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        startDate: convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                        // firstOrderStartDate,
                        orderStatusCode:
                            appliedCategory?.categoryName ===
                            t('orders.orderListFilterDropDown.drafts')
                                ? appliedCategory?.orderType
                                : statusCode,
                        orderType:
                            appliedCategory?.categoryName ===
                            t('orders.orderListFilterDropDown.drafts')
                                ? selectedQuickFilter?.statusNotes.join(',')
                                : filter.orderType === 'ALL_ORDERS'
                                ? ''
                                : filter.orderType,
                        deniedOverrides:
                            Id === 4 &&
                            (deniedOverrideToggle ||
                                deniedOverrideToggleTemp) &&
                            displayDeniedOverride(
                                checkImpersonationActive() || checkProxyActive()
                                    ? sessionStorage.getItem('ProxyUserRole')
                                    : employeeRole,
                                countryISOCode
                            )
                                ? true
                                : false,
                    },
                    pageLimit: PAGE_LIMIT,
                    pageNo: 0,
                      isFromOrderHistory:isOrderHistory,
                })
            );
        }
    };

    useEffectWithErrorLogging(() => {
        // dispatch(getOrderSummaryData());
        //dispatch(setCategory(categoryList[0].orderType));
        if (
            appliedCategory.categoryName ===
            t('orders.orderQuickFilters.deniedUsageOverrides.name')
        ) {
            dispatch(setDeniedOverrideClicked(true));
        }
        if (!linkMyCaseRef) {
            closeOrderSummaryHandler();
        }

        dispatch(
            setSearchParams({
                account: '',
                hrefId: '',
                physician: '',
                surgeryDate: '',
                networkId: '',
                patientName: '',
                procedure: '',
                lotSerialNumber: '',
                myCaseRef: '',
                sapOrderId: '',
                purchaseOrderId: '',
                unidCaseId: '',
                trackingNumber: '',
                delivery: '',
                secondaryVendorCaseNo: '',
            })
        );
        //setShowSearchOrderResultsTable(false);
        dispatch(showHideSearchModalAction({ showSearchModal: false }));
        dispatch(
            setOrderDateAction({
                firstOrderStartDate:
                    firstOrderStartDate !== ''
                        ? convertDateToISOString(
                              new Date(firstOrderStartDate),
                              'start'
                          )
                        : '',
                orderListEndDate: endDate !== '' ? endDate : '',
            })
        );

        let orderType = '';
        let orderStatus = '';

        const checkDistrictSelectedEmpty =
            Object.keys(appliedDistrict).length === 0 &&
            appliedDistrict.constructor === Object;

        const checkTerritorySelectedEmpty =
            Object.keys(appliedTerritory).length === 0 &&
            appliedTerritory.constructor === Object;

        const checkAccountSelectedEmpty =
            Object.keys(appliedAccount).length === 0 &&
            appliedAccount.constructor === Object;

        const checkCategorySelectedEmpty =
            Object.keys(appliedCategory).length === 0 &&
            appliedCategory.constructor === Object;

        const checkQuickFilterEmpty =
            Object.keys(appliedQuickFilter).length === 0 &&
            appliedQuickFilter.constructor === Object;

        orderType = !checkCategorySelectedEmpty
            ? appliedCategory.categoryName ===
              t('orders.orderListFilterDropDown.all.categoryName')
                ? checkAppliedOrderTypeHandler(appliedOrderType)
                : appliedCategory.categoryName ===
                  t('orders.orderListFilterDropDown.drafts')
                ? !checkQuickFilterEmpty
                    ? !appliedQuickFilter.isDefault
                        ? appliedQuickFilter.statusCode
                        : checkAppliedOrderTypeHandler(appliedOrderType)
                    : ''
                : appliedCategory.orderType
            : '';

        orderStatus = !checkQuickFilterEmpty
            ? appliedCategory.categoryName ===
              t('orders.orderListFilterDropDown.drafts')
                ? appliedCategory.orderType
                : appliedQuickFilter.isDefault
                ? checkAppliedOrderStatusHandler(appliedOrderStatus)
                : appliedQuickFilter?.statusCode &&
                  appliedQuickFilter?.statusCode !== ''
                ? appliedQuickFilter.statusCode
                : ''
            : checkAppliedOrderStatusHandler(appliedOrderStatus);

        //Added Awaiting PO Enable/Disable
        if (
            (toggleCheckedDsktop || ToggleChecked) &&
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName')
        ) {
            const updateOrderStatus =
                orderStatus !== '' ? orderStatus.split(',') : [];
            if (!updateOrderStatus.includes('10013')) {
                updateOrderStatus.push('10013');
            }
            orderStatus =
                updateOrderStatus.length > 0 ? updateOrderStatus.join(',') : '';
        }
        if (checkCategorySelectedEmpty) {
            dispatch(setCategoryFilter({ ...categoryList?.[0] }));
            setCategoryName(categoryList?.[0]?.categoryName);
            setFilterActiveId('');
                resetAppliedFilter();
            setQuickFilterList([]);
            dispatch(setQuickFilter({}));
        } else {
            setCategoryName(appliedCategory.categoryName);
            let quickFilter = QuickFilterLabels(appliedCategory.categoryName);
            if (quickFilter?.length > 0) {
                setQuickFilterList(
                    isOrderHistory && orderHistoryRestoredDataRef.current
                        ? quickFilterApply(
                              quickFilter,
                              appliedCategory.orderType
                          )
                        : quickFilter
                );
                setFilterActiveId(
                    !checkQuickFilterEmpty
                        ? appliedQuickFilter.id
                        : quickFilter[0].id
                );
            }
        }

        const district = checkDistrictSelectedEmpty
            ? ''
            : appliedDistrict?.id
            ? appliedDistrict.id === 'All District'
                ? ''
                : appliedDistrict.id
            : '';
        const territory = checkTerritorySelectedEmpty
            ? ''
            : appliedTerritory?.id
            ? appliedTerritory.id === 'All Territory'
                ? ''
                : appliedTerritory.id
            : '';
        const account = checkAccountSelectedEmpty
            ? ''
            : appliedAccount?.id
            ? appliedAccount.id === 'All Account'
                ? ''
                : appliedAccount.id
            : '';
        dispatch(actionApplyFilterType('initial'));
        dispatch(getDistrict(true));
        //Normal Flow for Non-QuickFilters
        if (orderHistoryRestoredDataRef.current) {
            orderHistoryRestoredDataRef.current = false;
        } else if (
            // [DM_USER_ROLE, SM_USER_ROLE, CS_USER_ROLE, SR_USER_ROLE].includes(
            //     hybrisUserDetails.employeeRole
            // ) &&
            checkCategorySelectedEmpty ||
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') ||
            appliedCategory.categoryName ===
                t(
                    'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
                )
        ) {
            // dispatch(
            //     getOrderListData({
            //         startDate: convertDateToISOString(
            //             // minCreationDate,
            //             new Date(firstOrderStartDate),
            //             'start'
            //         ),
            //         // convertDateToISOString(
            //         //     firstOrderStartDate,
            //         //     'start'
            //         // ),
            //         endDate: endDate,
            //         orderTypeFilter: orderType,
            //         orderStatusCodesFilter: orderStatus,
            //         districtFilter: district,
            //         territoryFilter: territory,
            //         accountFilter: account,
            //         pageLimit: appliedUserFilters.pageLimit,
            //         pageNum: '0',
            //         sortOrder: appliedUserFilters.sortOrder,
            //         isActionItem: true,
            //         sortParam: appliedUserFilters.sortParam,
            //     })
            // );
            dispatch(
                getAllOrderListData({
                    startDate: convertDateToISOString(
                        // minCreationDate,
                        new Date(firstOrderStartDate),
                        'start'
                    ),
                    // convertDateToISOString(
                    //     firstOrderStartDate,
                    //     'start'
                    // ),
                    endDate: endDate,
                    orderTypeFilter: orderType,
                     notificationFailure:notificationFailureList?.[0]?.isChecked?true:false,
                    orderStatusCodesFilter: orderStatus,
                    districtFilter: district,
                    territoryFilter: territory,
                    accountFilter: account,
                    pageLimit: appliedUserFilters.pageLimit,
                    pageNum: '0',
                    sortOrder: appliedUserFilters.sortOrder,
                    isActionItem: true,
                    sortParam: appliedUserFilters.sortParam,
                    isFromOrderHistory: isOrderHistory,
                })
            );
        } else {
            //Two API Flow for QuickFilters
            twoCallAPIHandler(false, false);
        }
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar: false,
                admin: false,
                orders: !isDeniedOverrideClicked && !isOrderHistory,
                alerts: false,
                inventory: false,
                more: isOrderHistory,
                deniedUsageOverrides:
                    isDeniedOverrideClicked && !isOrderHistory,
                productGuide: false,
            })
        );
        let body = document.getElementById('body');
        if (isMobileView()) {
            body.style.backgroundColor = '#140f4b';
        }
        return () => {
            body.style.backgroundColor = '';
        };
    }, [callOrderOrCalendar, isDeniedOverrideClicked, ordersReselectTick]);

    useEffectWithErrorLogging(() => {
        if (!isOrderHistory) {
            return;
        }
        if (orderHistoryLocationKeyRef.current === location?.key) {
            return;
        }
        orderHistoryLocationKeyRef.current = location?.key;
        orderHistoryRestoredDataRef.current = false;
        const defaultCategory = categoryList?.[0];
        if (defaultCategory) {
            dispatch(setCategoryFilter({ ...defaultCategory }));
            setCategoryName(defaultCategory.categoryName);
        }
        setQuickFilterList([]);
        setFilterActiveId('');
        dispatch(setQuickFilter({}));
        dispatch(
            getAllOrderListData({
                startDate: convertDateToISOString(
                    new Date(firstOrderStartDate),
                    'start'
                ),
                endDate: endDate,
                orderTypeFilter: '',
                notificationFailure: notificationFailureList?.[0]?.isChecked
                    ? true
                    : false,
                orderStatusCodesFilter: '',
                districtFilter: '',
                territoryFilter: '',
                accountFilter: '',
                pageLimit: appliedUserFilters.pageLimit,
                pageNum: '0',
                sortOrder: appliedUserFilters.sortOrder,
                isActionItem: true,
                sortParam: appliedUserFilters.sortParam,
                isFromOrderHistory: isOrderHistory,
            })
        );
    }, [location?.key]);

    useEffectWithErrorLogging(() => {
        if (isOrderHistory) {
            return;
        }
        if (ordersReselectKeyRef.current === location?.key) {
            return;
        }
        ordersReselectKeyRef.current = location?.key;
        if (history.action !== 'PUSH') {
            return;
        }
        setOrdersReselectTick((tick) => tick + 1);
    }, [location?.key]);

    // useEffectWithErrorLogging(()=>{
    //     if(isDeniedOverrideClicked){
    //         onCategoryChangeHandler(3);
    //     }
    // },[isDeniedOverrideClicked]);

    const twoCallAPIHandler = (
        isPage,
        isDateDispatch,
        isDeniedOverrideToggle = false
    ) => {
        if (deniedOverrideToggle || deniedOverrideToggleTemp) {
            dispatch(
                getDeniedOrderFilter({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        deniedOverrides: true,
                        startDate: isDateDispatch
                            ? // ? orderListStartDate
                              convertDateToISOString(
                                  new Date(firstOrderStartDate),
                                  'start'
                              )
                            : filter.startDate,
                        endDate: isDateDispatch
                            ? orderListEndDate
                            : filter.endDate,
                        orderType: 'ZLB',
                        orderStatusCode: '12347,12348',
                    },
                })
            );
        }
        dispatch(
            refineFilterAndOrderList(
                {
                    filters: {
                        ...appliedUserFilters,
                        filter: {
                            ...filter,
                            deniedOverrides: isDeniedOverrideClicked,
                            startDate: isDateDispatch
                                ? // ? orderListStartDate
                                  convertDateToISOString(
                                      new Date(firstOrderStartDate),
                                      'start'
                                  )
                                : filter.startDate,
                            endDate: isDateDispatch
                                ? orderListEndDate
                                : filter.endDate,
                            orderType:
                                appliedCategory?.categoryName ===
                                    t(
                                        'orders.orderListFilterDropDown.drafts'
                                    ) ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderListFilterDropDown.all.categoryName'
                                    )
                                    ? ''
                                    : appliedCategory.orderType === 'ALL_ORDERS'
                                    ? ''
                                    : appliedCategory.orderType,
                            orderStatusCode:
                                appliedCategory?.categoryName ===
                                t(
                                    'orders.orderQuickFilters.deniedUsageOverrides.name'
                                )
                                    ? '12347,12348'
                                    : appliedCategory?.categoryName ===
                                      t('orders.orderListFilterDropDown.drafts')
                                    ? appliedCategory.orderType
                                    : '',
                            assignedFlag: filter.assignedFlag,
                        },
                        pageLimit: appliedUserFilters.pageLimit,
                        pageNo: isPage ? appliedUserFilters.pageNo : 0,
                    },
                    appliedQuickFilter: appliedQuickFilter,
                    appliedCategory: appliedCategory,
                    appliedOrderType:
                        checkAppliedOrderTypeHandler(appliedOrderType),
                    appliedOrderStatus:
                        checkAppliedOrderStatusHandler(appliedOrderStatus),
                    isAwaitingPo:
                        toggleCheckedDsktop || ToggleChecked ? true : false,
                    isAwatingPOStatusCode: '10013',
                      isFromOrderHistory:isOrderHistory,
                },
                false,
                deniedOverrideToggle || isDeniedOverrideToggle,
              
            )
        );
    };

    const dateChangeHandler = () => {
        dispatch(actionApplyFilterType('date'));
        const checkCategorySelectedEmpty =
            Object.keys(appliedCategory).length === 0 &&
            appliedCategory.constructor === Object;
        dispatch(
            setOrdersListFilter({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    startDate:
                        // firstOrderStartDate,
                        convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    endDate: orderListEndDate,
                },
            })
        );
        if (
            checkCategorySelectedEmpty ||
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') ||
            appliedCategory.categoryName ===
                t(
                    'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
                )
        ) {
            //Normal Flow for Non-QuickFilters
            // dispatch(
            //     getRefinedOrderListData({
            //         ...appliedUserFilters,
            //         filter: {
            //             ...filter,
            //             startDate: orderListStartDate,
            //             endDate: orderListEndDate,
            //         },
            //     })
            // );
            twoCallAPIHandler(false, true);
        } else {
            //Two API Flow for QuickFilters
            twoCallAPIHandler(false, true);
        }
    };

    const checkAppliedOrderTypeHandler = (appliedOrderType) => {
        let orderType = '';

        const selectedOrderType = appliedOrderType
            ?.filter((x) => x.isChecked === true)
            ?.map((a) => {
                if (a.statusCode === 'ALL_ORDERTYPE') {
                    return '';
                }
                return a.statusCode;
            });

        orderType =
            selectedOrderType?.length > 0 ? selectedOrderType.join(',') : '';

        return orderType;
    };

    const checkAppliedOrderStatusHandler = (appliedOrderStatus) => {
        let orderStatus = '';

        const selectedOrderStatus = appliedOrderStatus
            ?.filter((x) => x.isChecked === true)
            ?.map((a) => {
                if (a.statusCode === 'ALL_ORDERSTATUS') {
                    return '';
                }
                return a.statusCode;
            });

        orderStatus =
            selectedOrderStatus?.length > 0
                ? selectedOrderStatus.join(',')
                : '';
        return orderStatus;
    };

    useEffectWithErrorLogging(() => {
        if (linkMyCaseRef) {
            // selectedMycaseRefId(linkMyCaseRef);
            openOrderSummaryHandler(linkMyCaseRef);
        }
    }, [linkMyCaseRef]);

    const openOrderSummaryHandler = (myCaseRef, orderType='', isUsageMastOrder=false, isMastOrder = false) => {
        //Added for Dynatrace pageName identification
        dispatch(getConfigurations({resourceType: 'visibility', module: fromOrderTypeToModuleName(orderType, isMastOrder, isUsageMastOrder)}, ORDERS));
        setDynatracePageName(pageNames.ordersSummary);
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: !orderSummaryModal,
                isFromOrderHistory: isOrderHistory,
            })
        );
    };

    const closeOrderSummaryHandler = () => {
        dispatch(setDynamicZIndex(0));
        dispatch(setItemListView(false));
        if (linkMyCaseRef) {
            dispatch(
                closeOrderSummaryModalState({
                    myCaseRef: '',
                    orderSummaryModal: false,
                })
            );
            history.replace({
                pathname: '/orders',
                linkMyCaseRef: '',
            });
        } else {
            dispatch(
                closeOrderSummaryModalState({
                    myCaseRef: '',
                    linkMyCaseRef: '',
                    orderSummaryModal: false,
                })
            );
        }
        if (showSearchModal) {
            dispatch(toggleSearchResult(false));
        }
    };

    const onSearchOrderResultsCloseHandler = () => {
        dispatch(
            setSearchParams({
                account: '',
                hrefId: '',
                physician: '',
                surgeryDate: '',
                networkId: '',
                patientName: '',
                procedure: '',
                lotSerialNumber: '',
                myCaseRef: '',
                sapOrderId: '',
                purchaseOrderId: '',
                unidCaseId: '',
                trackingNumber: '',
                delivery: '',
                secondaryVendorCaseNo: '',
            })
        );
        //setShowSearchOrderResultsTable((prevState) => !prevState);
        dispatch(showHideSearchModalAction({ showSearchModal: false }));
    };

    const onAwayClickHandler = () => {
        setCategoryOpen(false);
    };

    const onNoRecordsHandler = () => {
        //check Applied Filter Ordertype
        const isAppliedOrderType =
            appliedOrderType?.filter(
                (x) => x.isChecked === true && x.statusCode !== 'ALL_ORDERTYPE'
            )?.length > 0
                ? true
                : false;
        //check Applied Filter OrderStatus
        const isAppliedOrderStatus =
            appliedOrderStatus?.filter(
                (x) =>
                    x.isChecked === true && x.statusCode !== 'ALL_ORDERSTATUS'
            )?.length > 0
                ? true
                : false;
        //check AppliedQuickFilter is Zero
        const isQuickFilterZero =
            !appliedQuickFilter?.isDefault && appliedQuickFilter.count === 0
                ? true
                : false;

        const checkDistrict =
            Object.keys(appliedDistrict).length === 0 &&
            appliedDistrict.constructor === Object
                ? false
                : appliedDistrict.id === 'All District'
                ? false
                : true;
        const checkTerritory =
            Object.keys(appliedTerritory).length === 0 &&
            appliedTerritory.constructor === Object
                ? false
                : appliedTerritory.id === 'All Territory'
                ? false
                : true;
        const checkAccount =
            Object.keys(appliedAccount).length === 0 &&
            appliedAccount.constructor === Object
                ? false
                : appliedAccount.id === 'All Account'
                ? false
                : true;

        const checkCategorySelectedEmpty =
            Object.keys(appliedCategory).length === 0 &&
            appliedCategory.constructor === Object;

        const isShowNoRecords =
            (isAppliedOrderType ||
                isAppliedOrderStatus ||
                isQuickFilterZero ||
                checkDistrict ||
                checkTerritory ||
                checkAccount ||
                !checkCategorySelectedEmpty) &&
            (orderList.length === 0 ? true : false)
                ? true
                : false;
        setIsShowNoOrders(isShowNoRecords);
    };
    const {isAllowed, statusCode} = useSelector((state) => state.checkOrderActionEligibilityReducer);
    
    const awaitingToggleHandler = (isActive) => {
        let prevOrderStatusCode = isActive ? '10013' : '';
        const selectedOrderType = '';

        // if (appliedCategory?.categoryName === 'All Orders') {
        //     let statusCodes =
        //         prevOrderStatusCode.split(',').filter((x) => x !== '').length >
        //         0
        //             ? prevOrderStatusCode.split(',')
        //             : [];
        //     if (isActive) {
        //         if (!statusCodes.includes('10013')) {
        //             statusCodes.push('10013');
        //         }
        //     } else {
        //         const indexStatus = statusCodes.findIndex((x) => x === '10013');
        //         if (indexStatus >= 0) {
        //             statusCodes.splice(indexStatus, 1);
        //         }
        //     }

        //     prevOrderStatusCode =
        //         statusCodes?.length > 0 ? statusCodes.join(',') : '';
        // }
        if (isActive) {
            dispatch(actionApplyFilterType('AppliedFilter'));
        } else {
            dispatch(actionApplyFilterType('ResetFilter'));
        }
        resetAppliedFilter(); // Reseting Previously Applied Filter
        dispatch(
            setOrdersListFilter({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    startDate:
                        // convertDateToISOString(firstOrderStartDate),
                        convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    orderType:
                        selectedOrderType === 'ALL_ORDERS'
                            ? ''
                            : selectedOrderType,
                    orderStatusCode: prevOrderStatusCode,
                },
            })
        );

        dispatch(
            getRefinedOrderListData({
                ...appliedUserFilters,
                filter: {
                    ...filter,
                    startDate:
                        // convertDateToISOString(firstOrderStartDate),
                        convertDateToISOString(
                            // minCreationDate,
                            new Date(firstOrderStartDate),
                            'start'
                        ),
                    orderType:
                        selectedOrderType === 'ALL_ORDERS'
                            ? ''
                            : selectedOrderType,
                    orderStatusCode: prevOrderStatusCode,
                      isFromOrderHistory:isOrderHistory,
                },
            })
        );
    };
    const deniedOverrideToggleHandler = (isActive) => {
        // dispatch(deniedToggleFilter(isActive));
        dispatch(deniedOverrideToggleClickChange(true));
        !isActive && dispatch(actionApplyFilterType('quickFilter'));
        let prevOrderStatusCode = '12347,12348';
        // let updatedFilter = categoryFilters[0]?.orderStatusList?.map((data) => {
        //     if (data?.code?.includes(prevOrderStatusCode)) {
        //         return filters[0]?.orderStatusList?.filter((d) =>
        //             d?.code?.includes(prevOrderStatusCode)
        //         );
        //     }
        // });
        // console.log(updatedFilter);
        if (isActive) {
            dispatch(
                getDeniedOrderFilter({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        deniedOverrides: true,
                        startDate:
                            // convertDateToISOString(firstOrderStartDate),
                            convertDateToISOString(
                                // minCreationDate,
                                new Date(firstOrderStartDate),
                                'start'
                            ),
                        orderType: 'ZLB',
                        orderStatusCode: prevOrderStatusCode,
                    },
                })
            );
        }
        dispatch(
            refineFilterAndOrderList(
                {
                    filters: {
                        ...appliedUserFilters,
                        filter: {
                            ...filter,
                            deniedOverrides: isDeniedOverrideClicked,
                            startDate: filter.startDate,
                            endDate: filter.endDate,
                            orderType:
                                appliedCategory?.categoryName ===
                                    t(
                                        'orders.orderListFilterDropDown.drafts'
                                    ) ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderListFilterDropDown.all.categoryName'
                                    )
                                    ? ''
                                    : appliedCategory.orderType === 'ALL_ORDERS'
                                    ? ''
                                    : appliedCategory.orderType,
                            orderStatusCode:
                                appliedCategory?.categoryName ===
                                t(
                                    'orders.orderQuickFilters.deniedUsageOverrides.name'
                                )
                                    ? '12347,12348'
                                    : appliedCategory?.categoryName ===
                                      t('orders.orderListFilterDropDown.drafts')
                                    ? appliedCategory.orderType
                                    : '',
                            assignedFlag: filter.assignedFlag,
                        },
                        pageLimit: appliedUserFilters.pageLimit,
                        pageNo: 0,
                    },
                    appliedQuickFilter: appliedQuickFilter,
                    appliedCategory: appliedCategory,
                    appliedOrderType:
                        checkAppliedOrderTypeHandler(appliedOrderType),
                    appliedOrderStatus:
                        checkAppliedOrderStatusHandler(appliedOrderStatus),
                    isAwaitingPo:
                        toggleCheckedDsktop || ToggleChecked ? true : false,
                    isAwatingPOStatusCode: '10013',
                      isFromOrderHistory:isOrderHistory,
                },
                false,
                isActive,
                
            )
        );
        // dispatch(
        //     setOrdersListFilter({
        //         ...appliedUserFilters,
        //         filter: {
        //             ...filter,
        //             deniedOverrides: isActive,
        //             startDate:
        //                 // convertDateToISOString(firstOrderStartDate),
        //                 convertDateToISOString(
        //                     // minCreationDate,
        //                     new Date(firstOrderStartDate),
        //                     'start'
        //                 ),
        //             orderType: 'ZLB',
        //             orderStatusCode: prevOrderStatusCode,
        //         },
        //     })
        // );

        // dispatch(
        //     getRefinedOrderListData({
        //         ...appliedUserFilters,
        //         filter: {
        //             ...filter,
        //             deniedOverrides: isActive,
        //             startDate:
        //                 // convertDateToISOString(firstOrderStartDate),
        //                 convertDateToISOString(
        //                     // minCreationDate,
        //                     new Date(firstOrderStartDate),
        //                     'start'
        //                 ),
        //             orderType: 'ZLB',
        //             orderStatusCode: prevOrderStatusCode,
        //         },
        //     })
        // );
    };

    let appliedViews = [];
    if (appliedAccount.name) {
        if (appliedAccount.name !== t('common.allLabel')) {
            appliedViews.push(appliedAccount.name);
        }
    }
    if (appliedDistrict.name) {
        if (appliedDistrict.name !== t('common.allLabel')) {
            appliedViews.push(appliedDistrict.name);
        }
    }
    if (appliedTerritory.name) {
        if (appliedTerritory.name !== t('common.allLabel')) {
            appliedViews.push(appliedTerritory.name);
        }
    }
    if (appliedOrderCondition.name) {
        if (
            appliedOrderCondition.name !==
            t('calendar.filterResultsPanel.assigned')
        ) {
            appliedViews.push(appliedOrderCondition.name);
        }
    }
    const isAppliedOrderType = appliedOrderType
        ?.filter(
            (x) => x.isChecked === true && x.statusCode !== 'ALL_ORDERTYPE'
        )
        ?.map((item) => item.description);

    const isAppliedOrderStatus = appliedOrderStatus
        ?.filter(
            (x) => x.isChecked === true && x.statusCode !== 'ALL_ORDERSTATUS'
        )
        ?.map((item) => item.description);
    const isNotificationFailureFilter= appliedNotificationFailure?.filter(
            (x) => x.isChecked === true
        )
        ?.map((item) => item.description);

    let appliedFilters = [...(isAppliedOrderStatus || []), ...(isAppliedOrderType || []),...(isNotificationFailureFilter || [])];

    const scrollHeightWithFilters =
        quickFilterList?.length > 0 &&
        (appliedFilters?.length > 0 || appliedViews?.length > 0);

    const ScrollNoQuickFilterList =
        quickFilterList?.length == 0 &&
        (appliedFilters?.length > 0 || appliedViews?.length > 0);

    const ScrollNoAppliedFilters =
        quickFilterList?.length > 0 &&
        (appliedFilters?.length == 0 || appliedViews?.length == 0);

    const deleteOrderHandler = () => {
        dispatch(deleteOrder(deleteMyCaseRef));
        dispatch(
            showDeleteOrderAction({
                isDeletePopup: false,
            })
        );
    };

    const deleteCloseHandler = () => {
        dispatch(
            showDeleteOrderAction({
                isDeletePopup: false,
                deleteMyCaseRef: '',
                isOtherUser: false,
            })
        );
        if (isOrderDetailsModal) {
            dispatch(
                showHideSummaryModal({
                    orderSummaryModal: true,
                })
            );
        }
    };

    const validateApplyButton = () => {
        let validateApply =
            convertDateToISOString(new Date(firstOrderStartDate), 'start') &&
            orderListEndDate
                ? convertDateToISOString(
                      new Date(firstOrderStartDate),
                      'start'
                  ) !== startDate || orderListEndDate !== endDate
                    ? false
                    : true
                : false;
        return validateApply;
    };

    const filterRef = useRef(null);
    const actionPanelRef = useRef(null);

    const poRef = useRef(null);

    // const AfterToggleChecked = () => {
    //     setToggleChecked((value) => !value);
    // };

    useEffectWithErrorLogging(() => {
        if (isToggleHandlerChanged) {
            if (ToggleChecked) {
                awaitingToggleHandler(true);
            } else {
                awaitingToggleHandler(false);
            }
            setIsToggleHandlerChanged(false);
        }
    }, [ToggleChecked, isToggleHandlerChanged]);

    const AfterToggleChecked = () => {
        setToggleChecked((value) => !value);
        //setToggleCheckedMobile((value) => !value);
        // dispatch(awaitingToggleMobile(toggleChecked));
        dispatch(awaitingToggleMobile(!ToggleChecked));
        setIsToggleHandlerChanged(true);
    };

    const options = [
        {
            value: 'order_date_oldest',
            label: t('orders.index.orderdateold'),
            className: 'customFontDropDown',
        },
        {
            value: 'order_date_newest',
            label: t('orders.index.orderDate'),
            className: 'customFontDropDown',
        },
        ...(!isOrderHistory
            ? [
                  {
                      value: 'account_az',
                      label: t('orders.index.Accountaz'),
                      className: 'customFontDropDown',
                  },
                  {
                      value: 'account_za',
                      label: t('orders.index.Accountza'),
                      className: 'customFontDropDown',
                  },
              ]
            : []),
    ];

    return (
        <OrderPageContainer id="ordersPage">
            <OrderHeader
                isSearch={showSearchModal}
                firstOrderStartDate={firstOrderStartDate}
                isOrderHistory={isOrderHistory}
            />
            <OrderContainer id="ordersContainer">
                <OrderPageContainer id="ordersPageContainer">
                    <FilterActionsContainer
                        id="filterContainer"
                        ref={filterRef}
                        IsAllOrder={
                            categoryName ==
                            t('orders.orderListFilterDropDown.all.categoryName')
                        }
                    >
                        <Category
                            categoryName={categoryName}
                            categoryOpen={categoryOpen}
                            categoryList={categoryList}
                            categoryChange={onCategoryChangeHandler}
                            categoryOpenHandler={onCategoryOpenHandler}
                            categoryAnchorEl={categoryAnchorEl}
                            clickAwayHandler={onAwayClickHandler}
                        />
                        {categoryName ==
                            t(
                                'orders.orderListFilterDropDown.all.categoryName'
                            ) &&
                            !isOrderHistory && (
                            <POToggleButtonContainer>
                                <ToggleButton
                                  id="orders-index-awaiting-po-toggle-button"
                                    label={t('orders.index.awaitingPO')}
                                    checked={ToggleChecked}
                                    // onChange={AfterToggleChecked}
                                    onChange={AfterToggleChecked}
                                />
                            </POToggleButtonContainer>
                        )}
                        {displayDeniedOverride(
                            checkImpersonationActive() || checkProxyActive()
                                ? sessionStorage.getItem('ProxyUserRole')
                                : employeeRole,
                            countryISOCode
                        ) &&
                            categoryName == 'Usage' &&
                            appliedQuickFilter.label == 'Pending Override' && (
                                <POToggleButtonContainer>
                                    <ToggleButton
                                     id="orders-my-denied-overrides-toggle-button"
                                        label={t(
                                            'orders.index.myDeniedOverrides'
                                        )}
                                        checked={deniedOverrideToggle}
                                        onChange={() => {
                                            try {
                                            deniedOverrideToggleHandler(
                                                !deniedOverrideToggle
                                            );
                                            dispatch(
                                                deniedToggle(
                                                    !deniedOverrideToggle
                                                )
                                            );
                                            dispatch(
                                                deniedToggleTemp(
                                                    !deniedOverrideToggle
                                                )
                                            );
                                             } catch (error) {
                                                 logErrorToConsole(error);
                                            }
                                        }}
                                        isMobileView={true}
                                    />
                                </POToggleButtonContainer>
                            )}
                        {quickFilterList?.length > 0 ? (
                            <>
                                <QuickFiltersContainer
                                    showFilterIcon={showFilterIcon}
                                    filterClick={onFilterClick}
                                    quickFilterList={quickFilterList}
                                    showFullFilter={showFullFilter}
                                    filterActiveId={filterActiveId}
                                    filterSwitch={onFilterActiveHandler}
                                />
                            </>
                        ) : null}
                    </FilterActionsContainer>
                    <>
                        <div ref={poRef}>
                            {!isOrderHistory &&
                            ((categoryName ==
                                t(
                                    'orders.orderListFilterDropDown.all.categoryName'
                                ) &&
                                (toggleCheckedDsktop || ToggleChecked)) ||
                                appliedQuickFilter.label ==
                                    t('orders.index.awaitingPO')) ? (
                                <AwaitingPOCard
                                    ipadproPortraitPadding={
                                        totalPoSum && '0px 20px 20px 5px'
                                    }
                                    ipadPortraitPadding={
                                        totalPoSum && '0px 20px 20px 5px'
                                    }
                                >
                                    <OrderStatusDiv>
                                        <ImageContainer>
                                            <POImg
                                                src={PaymentInformationNeeded}
                                            />
                                        </ImageContainer>
                                        <StatusContainer>
                                            {t('orders.index.awaitingPO')} (
                                            {totalSearcResults &&
                                            totalSearcResults
                                                ? totalSearcResults
                                                : '0'}
                                            )
                                        </StatusContainer>
                                    </OrderStatusDiv>
                                    <OrderDiv
                                        marginRight={!totalPoSum && '40px'}
                                    >
                                        <RevenueContainer>
                                            <RevenueText>
                                                {t(
                                                    'orders.index.UnbilledRevenue'
                                                )}
                                            </RevenueText>
                                            <RevenuePrice>
                                                {totalPoSum === 0 ||
                                                totalSearcResults === 0
                                                    ? setCurrencyFormat(0)
                                                    : totalPoSum &&
                                                      setCurrencyFormat(
                                                          totalPoSum
                                                      )}
                                            </RevenuePrice>
                                        </RevenueContainer>
                                        {totalPoSum === 0 ||
                                        totalSearcResults === 0 ? (
                                            <ImageContainer>
                                                <POImg src={BriefcaseIcon} />
                                            </ImageContainer>
                                        ) : (
                                            <TissueAndNonTissueDiv>
                                                <ImageContainer
                                                    marginLeft={'30px'}
                                                    mbMarginBottom={'3px'}
                                                    ipadMarginBottom={'10px'}
                                                    ipadproMarginBottom={'10px'}
                                                >
                                                    {countryISOCode == 'US' ? (
                                                        <img
                                                            src={NonTissueIcon}
                                                            alt="NT"
                                                            width={'24px'}
                                                            height={'18px'}
                                                        />
                                                    ) : null}
                                                    <NonTissueItemPrice>
                                                        {setCurrencyFormat(
                                                            nonTissuePoSum
                                                        )}
                                                    </NonTissueItemPrice>
                                                </ImageContainer>

                                                <ImageContainer
                                                    marginLeft={'30px'}
                                                >
                                                    {countryISOCode == 'US' ? (
                                                        <img
                                                            src={TissueIcon}
                                                            alt="T"
                                                            width={'24px'}
                                                            height={'18px'}
                                                        />
                                                    ) : null}
                                                    <TissueItemPrice>
                                                        {setCurrencyFormat(
                                                            tissuePoSum
                                                        )}
                                                    </TissueItemPrice>
                                                </ImageContainer>
                                            </TissueAndNonTissueDiv>
                                        )}
                                    </OrderDiv>
                                </AwaitingPOCard>
                            ) : null}
                        </div>
                        <div ref={actionPanelRef}>
                            {categoryName ===
                                t(
                                    'orders.orderListFilterDropDown.all.categoryName'
                                ) &&
                                !ToggleChecked && (
                                    <LineSeparator
                                        style={{
                                            margin: '-4px 10px 15px 15px',
                                        }}
                                    />
                                )}
                            <ActionPanel
                                datePickerDivWidth="124px"
                                datePickerDivHeight="26px"
                                datePickerDivMbWidth="120px"
                                datePickerDivMbHeight="28px"
                                padding={'0 0 0 10px'}
                                ordersDateIconLeft={'10px'}
                                startDate={
                                    firstOrderStartDate === ''
                                        ? ''
                                        : new Date(firstOrderStartDate)
                                }
                                firstOrderStartDate={firstOrderStartDate}
                                endDate={
                                    orderListEndDate === ''
                                        ? ''
                                        : new Date(orderListEndDate)
                                }
                                minDate={
                                    isOrderHistory
                                        ? orderHistoryMinDate
                                        : minCreationDate
                                }
                                isOrdersListView={true}
                                margin={'0 5px 0 5px'}
                                mbMargin={'0 5px 0 0'}
                                iconHeight={isMobileView() ? '17px' : null}
                                iconPaddingTop={isMobileView() ? '5%' : null}
                                iconRight={isMobileView() ? '4%' : null}
                                dateChangeHandler={dateChangeHandler}
                                setFirstOrderStartDate={setFirstOrderStartDate}
                                isApplyEnabled={() => validateApplyButton()}
                                fromOrderPage={true}
                                desktopToggleChecked={toggleCheckedDsktop}
                                deniedOverrideToggle={deniedOverrideToggle}
                                toggleCheckedHandler={(value) => {
                                    //setToggleCheckedDsktop(value);
                                    awaitingToggleHandler(value);
                                    dispatch(awaitingToggle(value));
                                }}
                                deniedOverrideToggleCheck={(value) => {
                                    //setToggleCheckedDsktop(value);
                                    deniedOverrideToggleHandler(value);
                                    dispatch(deniedToggle(value));
                                    dispatch(deniedToggleTemp(value));
                                }}
                                showToggleButtons={true}
                                isOrderHistory={isOrderHistory}
                            />
                            {categoryName ===
                                t(
                                    'orders.orderListFilterDropDown.all.categoryName'
                                ) && ToggleChecked ? (
                                <LineSeparator />
                            ) : categoryName !==
                              t(
                                  'orders.orderListFilterDropDown.all.categoryName'
                              ) ? (
                                <LineSeparator />
                            ) : null}
                            <DropDownSection>
                                <div>
                                    <img src={SortGeneral} />
                                </div>
                                <div
                                    style={{
                                        width: '100%',
                                        marginLeft: '10px',
                                    }}
                                >
                                    <Select
                                        id="orders-index-orders-orderDate"
                                        height={'40px'}
                                        width={'100%'}
                                        placeholder={t(
                                            'orders.index.orderDate'
                                        )}
                                        options={options}
                                        value={mobileFilterDropdownValue}
                                        onChange={onhandleFilterChange}
                                        scrollHeight={'365px'}
                                        selectedLabelFontSize={'14px'}
                                        labelColor={'#202124'}
                                        borderRadius={'6px'}
                                    />
                                </div>
                            </DropDownSection>
                            <FilterResultsPanel
                                appliedViews={appliedViews}
                                appliedFilters={appliedFilters}
                                // mobileWidth={'95%'}
                                width={'100%'}
                                filterContainerMobilePadding={'0px 0px'}
                                mobileMargin={'0 0 0 1rem'}
                                noExtraBorder={true}
                                // isTemplate = {true}
                                clearFilterHandler = {handleClearClick}
                            />
                        </div>
                        {/* <MobileView>
                            <hr style={{ margin: '4px 15px', opacity: 0.4 }} />
                        </MobileView> */}
                        {!isShowNoOrders ? (
                            <>
                                <DesktopView ref={orderTableRef}>
                                    <OrdersListTableView
                                        onBlur={resumeScrolling}
                                        onFocus={hideScrolling}
                                        openOrderSummaryHandler={
                                            openOrderSummaryHandler
                                        }
                                        totalNumberOfRecords={totalSearcResults}
                                        scrollHeightWithFilters={
                                            scrollHeightWithFilters
                                        }
                                        scrollHeight={true}
                                        scrollNoAppliedFilters={
                                            ScrollNoAppliedFilters
                                        }
                                        scrollHeightNoQuickFilter={
                                            ScrollNoQuickFilterList
                                        }
                                        orderListPageLimt={pageLimit}
                                        firstOrderStartDate={
                                            firstOrderStartDate
                                        }
                                        disablePaginator={false}
                                        isOrderHistory={isOrderHistory}
                                        parentRef={[
                                            filterRef,
                                            actionPanelRef,
                                            poRef,
                                        ]}
                                        retriggerEventNotification={retriggerEventNotification}
                                        setRetriggerEventNotification={setRetriggerEventNotification}
                                        setNotificationDetails={setNotificationDetails}
                                        notificationDetails={notificationDetails}
                                    
                                    />
                                </DesktopView>

                                <MobileView>
                                    <OrdersListCardView
                                        openOrderSummaryHandler={
                                            openOrderSummaryHandler
                                        }
                                        firstOrderStartDate={
                                            firstOrderStartDate
                                        }
                                        totalNumberOfRecords={totalSearcResults}
                                        orderListPageLimt={pageLimit}
                                        setNotificationDetails={setNotificationDetails}
                                        notificationDetails={notificationDetails}
                                        isOrderHistory={isOrderHistory}
                                    />
                                </MobileView>
                            </>
                        ) : !ordersLoading && orderList.length === 0 ? (
                            <>
                                <MobileView>
                                    <div
                                        style={{
                                            margin: '10px 18px',
                                            minHeight: '70vh',
                                        }}
                                    >
                                        {t(
                                            'orders.searchOrdersPanel.MobileViewMsg'
                                        )}
                                    </div>
                                </MobileView>
                                <DesktopView>
                                    <div style={{ margin: '10px 0' }}>
                                        {t(
                                            'orders.searchOrdersPanel.MobileViewMsg'
                                        )}
                                    </div>
                                </DesktopView>
                            </>
                        ) : null}
                    </>
                </OrderPageContainer>
            </OrderContainer>

            <OrderDetails
                showOrderListDetails={orderSummaryModal}
                orderListDetailsClose={closeOrderSummaryHandler}
                fromCalendar={false}
                fromListScreen={false}
                isOrderHistory={isOrderHistory}
                  retriggerEventNotification={retriggerEventNotification}
                                        setRetriggerEventNotification={setRetriggerEventNotification}
                                        setNotificationDetails={setNotificationDetails}
            />
            {showReportProcedureModal ? (
                <ReportProcedureData
                    showReportProcedureModal={showReportProcedureModal}
                    procedureInfoData={procedureInfoData}
                    setProcedureInfoData={setProcedureInfoData}
                    isErrorFoundInProcedure={isErrorFoundInProcedure}
                    isErrorFoundInFirstLevel={isErrorFoundInFirstLevel}
                />
            ) : null}

            <SearchOrderResults
                showSearchOrderResultsTable={showSearchModal}
                searchOrderResultsClose={onSearchOrderResultsCloseHandler}
                showOrdersResult={showOrdersResult}
                isOrderHistory={isOrderHistory}
                parentRef={[filterRef, actionPanelRef]}
                openOrderSummaryHandler={openOrderSummaryHandler}
                retriggerEventNotification={retriggerEventNotification}
                setRetriggerEventNotification={setRetriggerEventNotification}
                setNotificationDetails={setNotificationDetails}
                notificationDetails={notificationDetails}
            />
            {isDeletePopup ? (
                <DeleteOrderPopup
                    deleteOrderHandler={deleteOrderHandler}
                    onDeleteClose={deleteCloseHandler}
                    isOtherUser={isOtherUser}
                />
            ) : null}
            {summaryLoading ||
            ordersLoading ||
            deleteLoading ||
            updateSurgeryLoading ||
            (isCancelWithoutReason && cancelUsageInProgress) ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="orders-index-index-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                </Backdrop>
            ) : (
                <></>
            )}
            {cancelSurgeryData && 
                Object.keys(cancelSurgeryData).length > 0 &&
                (showNoUsageToReportPopup ||
                    showCancelSurgeryPopup ||
                    viewProcedureScreen ||
                    showUnidPostponePopup ||
                    showCaseCancelOrPostpone) && (
                    <NoUsageToReportContainer
                        cancelSurgeryData={cancelSurgeryData}
                        showNoUsageToReportPopup={showNoUsageToReportPopup}
                        showCancelSurgeryPopup={showCancelSurgeryPopup}
                        viewProcedureScreen={viewProcedureScreen}
                        showUnidPostponePopup={showUnidPostponePopup}
                        showCaseCancelOrPostpone={showCaseCancelOrPostpone}
                    />
                )}
            {showContactLogisticsPopup && (
                <WarningModal
                 id="orders-contact-logistics-warning-modal"
                    noWarningImg
                    title={t('calendar.preventShipping')}
                    message={t('calendar.cancellationOrders')}
                    onClose={() =>
                        dispatch({
                            type: SET_SHOW_CONTACT_LOGISTICS_POPUP,
                            payload: false,
                        })
                    }
                    webHeight={'70px'}
                    modalContentWidth={'375px'}
                    modalContentHeight={'120px'}
                    titleWidth={'285px'}
                    titleWebWidth={'380px'}
                    titleColor={isLanguageChanged && '#ED002A'}
                    messageColor={isLanguageChanged && '#ED002A'}
                />
            )}
            {showOrderSummaryFailurePopUp && (
                <WarningModal
                 id="orders-index-order-summary-failure-warning-modal"
                    // noWarningImg
                    title={t('orders.index.ErrorMessage')}
                    message={t('orders.index.InvalidMyCASEReferenceNumber')}
                    message2={t('orders.index.please')}
                    onClose={() => {
                        try {
                        setShowOrderSummaryFailurePopUp(false);
                        if (showSearchModal) {
                            dispatch(toggleSearchResult(false));
                        }
                         } catch (error) {
                           logErrorToConsole(error);
                         }
                    }}
                    webHeight={'40px'}
                    mbHeight={'60px'}
                    modalContentWidth={'375px'}
                    modalContentHeight={'120px'}
                    titleWidth={'285px'}
                    titleWebWidth={'380px'}
                />
            )}
        </OrderPageContainer>
    );
};

export default Orders;

const OrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 0;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    opacity: 1;
    /* height: calc(100vh - 120px) !important; */
    ${media.mobileDevice`
        border-top-left-radius: ${({ hideBorderRadius }) =>
            hideBorderRadius ? '0px' : '20px'};
        border-top-right-radius: ${({ hideBorderRadius }) =>
            hideBorderRadius ? '0px' : '20px'};
        /*padding: 0 0 3.5rem 0;*/
        /* margin-top: 32%;//Incase of using margin-top use rem, px*/
        height: auto;
        position: fixed;
        width: 100%;
         overflow-y: scroll;
        overflow-x: hidden;
    `}
`;

export const FilterActionsContainer = styled.div`
    margin: 0;
    ${media.mobileDevice`
        padding: 0.95rem;
        display: ${({ IsAllOrder }) => (IsAllOrder ? 'flex' : '')};
        align-items: ${({ IsAllOrder }) => (IsAllOrder ? 'center' : '')};
    `}

    @media screen and (max-device-width: 360px) {
        padding: 0.95rem 0.95rem 0.45rem 0.95rem;
    }
`;

export const MobileView = styled.div`
    display: none;

    ${media.mobileDevice`
        display: block;
        width: 100%;
        flex-grow: ${({ flexGrow }) => flexGrow};
        overflow-y: ${({ overFlowY }) => overFlowY};
        overflow-x: ${({ overFlowX }) => overFlowX};
        //min-height: 65vh;
    `}
`;
export const DesktopView = styled.div`
    display: block;

    ${media.mobileDevice`
        display: none;
    `}
`;

export const OrderPageContainer = styled.div`
    height: auto;
    width: 100%;
    ${media.mobileDevice`
        height: calc(100vh - 100px);
    `}
`;

export const POToggleButtonContainer = styled.div`
    display: none;
    ${media.mobileDevice`
    display: block;
    `}
`;

export const DropDownSection = styled.div`
    display: none;

    ${media.mobileDevice`
        display: flex;
        justify-content: space-between;
        padding: 13px 16px 11px 16px;
        align-items: center;
    `}
`;

export const AwaitingPOCard = styled.div`
    display: flex;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dedede;
    border-radius: 6px;
    padding: 12px 20px 10px 5px;
    justify-content: space-between;

    //ipad Pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        padding: ${(props) =>
            props.ipadproPortraitPadding
                ? props.ipadproPortraitPadding
                : '12px 20px 10px 5px'};
    }

    ${media.smalDevice`
    padding:  ${(props) =>
        props.ipadPortraitPadding
            ? props.ipadPortraitPadding
            : '12px 20px 10px 5px'};
    `}

    ${media.mobileDevice`
        margin: 0 13px 10px 13px;
        padding: 15px 30px 15px 0px;
        flex-direction: column;
        position: relative;
        /* ::after {
            content: '';
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 9px solid #fff;
            top: 115px;
            position: absolute;
            right: 47%;
    } */
    `}
`;

export const OrderStatusDiv = styled.div`
    display: flex;
    align-items: center;
    ${media.smalDevice`
        align-items: center;
    `}
`;

export const POImg = styled.img`
    width: 38px;
    height: 38px;
`;

export const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '10px')};

    //ipad Pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        margin-bottom: ${(props) =>
            props.ipadproMarginBottom ? props.ipadproMarginBottom : ''};
    }

    ${media.smalDevice`
        margin-left: 10px;
        margin-bottom:  ${(props) =>
            props.ipadMarginBottom ? props.ipadMarginBottom : ''};
    `}
    ${media.mobileDevice`
        margin-left: 10px;
        margin-bottom:  ${(props) =>
            props.mbMarginBottom ? props.mbMarginBottom : ''};
    `}
`;

export const POImageContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 0px;
`;

export const StatusContainer = styled.div`
    color: #000000;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    margin-left: 10px;
    ${media.mobileDevice`
    margin-bottom: 7px;
    `}
`;

export const OrderDiv = styled.div`
    display: flex;
    ${media.mobileDevice`
        justify-content: space-between;
        margin-left: 58px;
        margin-right: ${(props) =>
            props.marginRight ? props.marginRight : ''};
    `}
`;

export const RevenueContainer = styled.div`
    display: flex;
    align-items: center;
    ${media.mobileDevice`
        align-items: flex-start;
        flex-direction: column;
    `}
`;

export const RevenueText = styled.div`
    font-size: 12px;
    margin-right: 10px;
    color: #140f4b;
`;

export const RevenuePrice = styled.div`
    font-family: 'AvenirNextWorld Bold';
    font-size: 15px;
    color: #140f4b;
`;

export const TissueItemPrice = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    margin-left: 4px;
    color: #140f4b;
    ${media.mobileDevice`
        font-size: 11px;
        margin-left: 4px;
        font-family: 'AvenirNextWorld Regular';
        color: #0D0D0D;
    `}
`;

export const NonTissueItemPrice = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    margin-left: 4px;
    color: #140f4b;
    ${media.mobileDevice`
        font-size: 11px;
        margin-left: 4px;
        font-family: 'AvenirNextWorld Regular';
        color: #0D0D0D;
    `}
`;
export const LineSeparator = styled.hr`
    display: none;
    ${media.mobileDevice`
    display:block;
    border: 1px solid #707070;
    opacity: 0.1;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    margin: ${({ mobileMargin }) =>
        mobileMargin ? mobileMargin : '18px 5px 0px 15px'};
    `}
`;

export const TissueAndNonTissueDiv = styled.div`
    display: flex;
    margin-left: 1rem;

    //ipad Pro(10.5 inch) portrait
    @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        display: block;
        margin-top: 30px;
    }

    /* @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        flex-direction: column;
    }
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) {
        flex-direction: column;
    } */
    ${media.smalDevice`
        flex-direction: column;
        margin-left: 25px;
        margin-top: 28px;
    `}

    ${media.mobileDevice`
        margin-left: 0;
        line-height: 2;
        margin-top: 0px;
    `}
`;
